import { gunterzBold } from '@/theme/fonts';
import { Group, Paper, Stack, Text } from '@mantine/core';
export type ReferralMissionItemProps = {
  step: number;
  mission: string;
};
export const ReferralMissionItem: React.FC<ReferralMissionItemProps> = ({
  step,
  mission
}) => {
  return <Group gap={0}>
      <Stack align="center" w={40} h={40} bg="var(--input-variant-color)" style={{
      borderRadius: 5
    }}>
        <Text fz={20} ta="center" my="auto" className={gunterzBold.className} c="var(--text-prime)" lh="20px">
          {step}
        </Text>
      </Stack>
      <Paper h={32} flex={1} radius={0} bg="var(--bg-400)" style={{
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5
    }}>
        <Text tt="uppercase" fz={12} fw={700} c="var(--text-dark)" mx={10} my={8}>
          {mission}
        </Text>
      </Paper>
    </Group>;
};